import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import TVProductLobbyContentsCarrouselItemsBlockData from 'app/Models/Content/TVProductLobbyContentsCarrouselItemsBlockData';
import TVProductLobbyContentsCarrouselItemBlockData from 'app/Models/Content/TVProductLobbyContentsCarrouselItemBlockData';
import MarketingImageBlockData from 'app/Models/Content/MarketingImageBlockData';

import React from 'react';
import TVSlider, {TVSliderProps} from './TVSlider';
import {getImageProps} from 'app/utilities/ImageProps';

const TVProductLobbyContentsCarrouselItemsBlock = ({data, context}: ComponentProps<TVProductLobbyContentsCarrouselItemsBlockData>) => {
  const items = data.items.expandedValue as TVProductLobbyContentsCarrouselItemBlockData[];

  const extractItem = (item: TVProductLobbyContentsCarrouselItemBlockData) => ({
    subtitle: item.subtitle.value,
    images: item.images.expandedValue.map(({image}: MarketingImageBlockData) => ({...getImageProps(image, context)})),
    iconImage: item.iconImage?.value ? {...getImageProps(item.iconImage, context)} : null,
  });

  const carousels: TVSliderProps[] = [];
  items[0] && carousels.push({...extractItem(items[0]), size: 226, gap: 9, duration: 10});
  items[1] && carousels.push({...extractItem(items[1]), size: 226, gap: 9, duration: 13});
  items[2] && carousels.push({...extractItem(items[2]), size: 100, columns: 2, gap: 5, duration: 16, isChannels: true});

  return (
    <div className='TVProductLobbyContentsCarrouselItemsBlock'>
      {carousels.map((item, i) => (
        <TVSlider key={i} {...item} />
      ))}
    </div>
  );
};

export default TVProductLobbyContentsCarrouselItemsBlock;
